/**
 * Customer data normalization module.
 * Transforms integration-specific data into a unified shape for the Contact Details sidebar.
 */

export {
  FITDEGREE_RESERVATION_EVENTS,
  normalizeFitdegreeActivity,
  normalizeFitdegreeIntroOffer,
  normalizeFitdegreeMembership,
  normalizeFitdegreeOwnedItems,
  normalizeFitdegreeReservationsFromEvents,
  normalizeFitdegreeSpend,
  normalizeFitdegreeStats,
  transformFitdegreeEventToReservation,
} from "./fitdegree";
// Re-export individual normalizers for cases where fine-grained control is needed
export {
  normalizeMarianaTekActivity,
  normalizeMarianaTekMemberships,
  normalizeMarianaTekProfileReservations,
  normalizeMarianaTekReservations,
  normalizeMarianaTekReservationsFromEvents,
  normalizeMarianaTekUserDetails,
  transformMarianaTekEventToReservation,
} from "./mariana-tek";
export {
  hasMindbodyNormalizedState,
  MINDBODY_RESERVATION_EVENTS,
  normalizeMindbodyActivity,
  normalizeMindbodyIntroOffer,
  normalizeMindbodyMembership,
  normalizeMindbodyOwnedItems,
  normalizeMindbodyReservationsFromEvents,
  normalizeMindbodySpend,
  normalizeMindbodyStats,
  transformMindbodyEventToReservation,
} from "./mindbody";
export type { IntegrationData } from "./normalize";
export {
  detectReservationSource,
  mergeProfileReservations,
  type NormalizedReservations,
  normalizeReservationsFromEvents,
  profileReservations,
  type ReservationSource,
  reservationEventsQuery,
} from "./reservations";
export { hasIntegrationData, normalizeCustomerData } from "./normalize";
export {
  activeProviderIds,
  fieldHasInstalledSource,
  hasActiveFitnessIntegration,
  hasActivePulseIntegration,
  type PickedEventSource,
  type PickedPropertySource,
  pickActiveSource,
  pickEventSource,
  pickPrimaryProvider,
  pickPropertySource,
  resolveVertical,
} from "./pick-source";
export {
  getTaxonomyField,
  getVerticalTaxonomy,
  groupTaxonomyByCategory,
  NIGHTLIFE_CATEGORIES,
  NIGHTLIFE_TAXONOMY,
  SEGMENT_CATEGORIES,
  SEGMENT_TAXONOMY,
  type TaxonomyCategory,
  type TaxonomyCategoryId,
  type TaxonomyEventField,
  type TaxonomyEventSource,
  type TaxonomyField,
  type TaxonomyPropertyField,
  type TaxonomyPropertySource,
  type Vertical,
  WELLNESS_CATEGORIES,
  WELLNESS_TAXONOMY,
} from "./segment-taxonomy";
export {
  getTablelistExtras,
  normalizeTablelistActivity,
  normalizeTablelistSpend,
} from "./tablelist";
export {
  type CuratedCategoryGroup,
  type CuratedMenuEntry,
  type ExtraEventEntry,
  type ExtraPropertyEntry,
  type MergedTaxonomy,
  mergeTaxonomyWithSampled,
} from "./taxonomy-merge";
export * from "./types";
export {
  type ZenotiPackageItem,
  type ZenotiProperties,
  type ZenotiPurchaseItem,
  type ZenotiVisitItem,
  type ZenotiVisitStatus,
  zenotiCredits,
  zenotiDay,
  zenotiEventsQuery,
  zenotiMembershipTerm,
  zenotiPackageList,
  zenotiProperties,
  zenotiPurchasesFromEvents,
  zenotiSessionsLabel,
  zenotiVisitsFromEvents,
} from "./zenoti";
